import { CommonModule, NgOptimizedImage } from '@angular/common';
import { Component, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { Router, RouterModule } from '@angular/router';
import { take } from 'rxjs';
import { SmallNumberPipe } from 'src/app/pipes/small-number/small-number.pipe';
import { AuthService } from 'src/app/services/auth-service/auth-service.service';
import { TopItemsService } from 'src/app/services/top-items/top-items.service';
import { AfmStats } from 'src/app/shared/models/top-items.model';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  imports: [CommonModule, RouterModule, MatIconModule, MatButtonModule, MatExpansionModule, MatCardModule, SmallNumberPipe, NgOptimizedImage],
})
export class HomeComponent {
  afmStats = signal<AfmStats | undefined>(undefined);

  constructor(
    public authService: AuthService,
    private router: Router,
    private topItemsService: TopItemsService
  ) {
    this.topItemsService
      .getAfmStats()
      .pipe(take(1))
      .subscribe((afmStats) => {
        this.afmStats.set(afmStats);
      });
  }

  openLink(link: string) {
    window.open(link, '_blank');
  }
  openSupportLink() {
    this.router.navigate(['/support-us']);
  }
}
